module.exports = __webpack_public_path__ + "static/media/like.0b6ceb47.svg";